import { createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77388ee0")

_pushScopeId("data-v-77388ee0")
const _hoisted_1 = { class: "flex flex-row items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "ml-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      tabindex: "0",
      type: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args)), ["prevent"]), ["space"])),
      style: {
        '--toggle-width': _ctx.width,
        '--toggle-height': _ctx.height,
        '--toggle-knob-size': _ctx.knobSize,
        '--toggle-knob-shadow': _ctx.knobShadow
      },
      class: [
        'toggle-switch flex items-center',
        _ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        _ctx.modelValue
          ? `toggle-active ${_ctx.styleActive || 'bg-red-lp-2400'}`
          : _ctx.styleInactive || 'bg-gray-lp-200'
      ]
    }, [
      _hoisted_2
    ], 38),
    (_ctx.customLabel)
      ? _renderSlot(_ctx.$slots, "custom-label", { key: 0 }, undefined, true)
      : (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.modelValue ? _ctx.textActive : _ctx.textInactive), 1))
  ]))
})